import { render, staticRenderFns } from "./addDealerDialog.vue?vue&type=template&id=878fd6e8"
import script from "./addDealerDialog.vue?vue&type=script&lang=js"
export * from "./addDealerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports